// extracted by mini-css-extract-plugin
export default {"content":"SelectTypeStep_content__NOWru","subtitle":"SelectTypeStep_subtitle__GcMGD"};